module.exports = __webpack_public_path__ + "img/hologram-map-background.8da0336f.svg";